<template lang="pug">
.log-wrapper
  .text-center.mb-4
    h1.headline.mb-3.animated.fadeInDown {{ $t('message.denied') }}
    h3.mb-3.animated.fadeInDown {{ $t('message.relogin') }}
    .form-group.m-auto.w-70
      b-button(to="/login" type="button" size="xs" variant="primary").btn-block.noboxshadow.br-8
        i.fa.fa-sign-in-alt.mr-1
        span {{ $t("ui.login") }}
</template>

<script>
export default {
  components: {},
  computed: {},
  methods: {}
};
</script>
